module.exports = null;


//////////////////
// WEBPACK FOOTER
// ./build/jquery-stub.js
// module id = gEn0
// module chunks = 32